import React from 'react';
import { Navigate } from 'react-router-dom';
import { Types } from '../shared';

export interface IAdminRoute {
  isAuth: boolean;
  employee: any;
  children: React.ReactNode;
}

const AdminRoute: React.FC<IAdminRoute> = ({ isAuth, employee, children }) => {
  if (!isAuth) {
    return <Navigate to="/login" replace />;
  }

  if (employee && employee.type === Types.SuperAdmin) {
    return <>{children}</>;
  }

  return <Navigate to="/" replace />;
};

export default AdminRoute;
